import { useTranslation } from 'react-i18next'
import styles from './Footer.module.scss'
import MhrLogo from '../../assets/images/mhr-logo.png'
import ArvsfondenLogo from '../../assets/images/arvsfonden-logo.png'
import { Link } from '../../components'

const Footer = () => {
  const { t } = useTranslation()
  return (
    <footer className={styles.footer}>
      <div className={styles.leftCol}>
        <Link variant="simple" size="small" to="/cookie-policy">
          {t('common:start:cookiepolicy')}
        </Link>
      </div>
      <div>
        <a
          href="https://www.arvsfonden.se/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={ArvsfondenLogo}
            alt={t('common:start:arvsfondenlogoalttext')}
            width="206"
            height="50"
            className={styles.arvsfondenLogo}
          />
        </a>
        <a
          href="https://myhumanrights.se/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={MhrLogo}
            alt={t('common:start:logoalttext')}
            width="78"
            height="50"
            className={styles.mhrLogo}
          />
        </a>
      </div>
    </footer>
  )
}

export default Footer
